<template>
  <div class="svg-container">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 401 665"
      style="enable-background: new 0 0 401 665"
      xml:space="preserve"
    >
      <circle id="Heart_right" class="st0" cx="313.3" cy="267.97" r="15.3" />
      <circle id="Heart_left" class="st0" cx="187.67" cy="264.73" r="15.67" />
      <g id="people">
        <circle class="st1" cx="163.51" cy="96.47" r="5.28" />
        <circle class="st1" cx="163.51" cy="75.85" r="5.28" />
        <circle class="st1" cx="163.51" cy="55.27" r="5.28" />
        <circle class="st1" cx="163.51" cy="32.69" r="5.28" />
        <circle class="st1" cx="163.51" cy="12.07" r="5.28" />
        <circle class="st1" cx="17.39" cy="192.73" r="7.2" />
        <circle class="st1" cx="16.98" cy="172.7" r="7.2" />
        <circle class="st1" cx="65.02" cy="440.5" r="7.2" />
        <circle class="st1" cx="65.6" cy="485.15" r="7.2" />
        <circle class="st1" cx="65.6" cy="507.35" r="7.2" />
        <circle class="st1" cx="65.19" cy="463.47" r="7.2" />
        <circle class="st1" cx="91.58" cy="431.78" r="7.2" />
        <circle class="st1" cx="92.16" cy="484.11" r="7.2" />
        <circle class="st1" cx="91.75" cy="461.33" r="7.2" />
        <circle class="st1" cx="15.85" cy="441.41" r="7.2" />
        <circle class="st1" cx="16.43" cy="486.06" r="7.2" />
        <circle class="st1" cx="16.43" cy="508.26" r="7.2" />
        <circle class="st1" cx="16.02" cy="464.38" r="7.2" />
        <circle class="st2" cx="39.18" cy="338.23" r="13.58" />
        <circle class="st2" cx="39.82" cy="364.3" r="13.58" />
        <circle class="st2" cx="66.17" cy="338.23" r="13.58" />
        <circle class="st3" cx="66.81" cy="364.3" r="13.58" />
        <circle class="st2" cx="40" cy="389.87" r="13.58" />
        <circle class="st2" cx="66.59" cy="389.87" r="13.58" />
        <circle class="st3" cx="66.81" cy="162.28" r="13.58" />
        <circle class="st3" cx="66.81" cy="134.84" r="13.58" />
        <circle class="st3" cx="66.81" cy="108.5" r="13.58" />
        <circle class="st2" cx="66.59" cy="187.85" r="13.58" />
        <circle class="st3" cx="40.47" cy="416.17" r="13.58" />
        <circle class="st2" cx="39.18" cy="313.42" r="13.58" />
        <circle class="st2" cx="39.18" cy="288.89" r="13.58" />
        <circle class="st2" cx="39.18" cy="264.99" r="13.58" />
        <circle class="st2" cx="66.17" cy="314.33" r="13.58" />
        <circle class="st2" cx="92.39" cy="337.46" r="13.58" />
        <circle class="st3" cx="93.03" cy="363.53" r="13.58" />
        <circle class="st2" cx="92.8" cy="389.1" r="13.58" />
        <circle class="st2" cx="92.39" cy="313.56" r="13.58" />
        <circle class="st2" cx="66.17" cy="289.52" r="13.58" />
        <circle class="st2" cx="66.17" cy="264.99" r="13.58" />
        <circle class="st2" cx="66.17" cy="241.08" r="13.58" />
        <circle class="st2" cx="66.65" cy="214.46" r="13.58" />
        <circle class="st3" cx="93.8" cy="135.3" r="13.58" />
        <circle class="st3" cx="93.8" cy="107.86" r="13.58" />
        <circle class="st3" cx="93.8" cy="81.52" r="13.58" />
        <circle class="st2" cx="93.57" cy="160.86" r="13.58" />
        <circle class="st2" cx="93.63" cy="187.47" r="13.58" />
        <circle class="st3" cx="120.02" cy="135.88" r="13.58" />
        <circle class="st3" cx="120.02" cy="108.44" r="13.58" />
        <circle class="st3" cx="120.02" cy="81.9" r="13.58" />
        <circle class="st3" cx="120.02" cy="54.46" r="13.58" />
        <circle class="st2" cx="119.8" cy="161.44" r="13.58" />
        <circle class="st2" cx="119.86" cy="188.05" r="13.58" />
        <circle class="st2" cx="92.39" cy="289.52" r="13.58" />
        <circle class="st2" cx="92.39" cy="264.99" r="13.58" />
        <circle class="st2" cx="92.39" cy="241.08" r="13.58" />
        <circle class="st2" cx="119.37" cy="214.87" r="13.58" />
        <circle class="st2" cx="92.86" cy="214.46" r="13.58" />
        <circle class="st2" cx="39.18" cy="242.45" r="13.58" />
        <circle class="st3" cx="42.31" cy="171.99" r="9.79" />
        <circle class="st4" cx="144.64" cy="53.02" r="9.79" />
        <circle class="st3" cx="119.75" cy="30.9" r="9.79" />
        <circle class="st3" cx="43.45" cy="135.87" r="9.79" />
        <circle class="st5" cx="39.81" cy="441.69" r="9.79" />
        <circle class="st5" cx="76.98" cy="535.31" r="9.79" />
        <circle class="st5" cx="39.81" cy="463.06" r="9.79" />
        <circle class="st4" cx="39.81" cy="484.5" r="9.79" />
        <circle class="st4" cx="39.81" cy="507.12" r="9.79" />
        <circle class="st5" cx="39.38" cy="217.27" r="11.8" />
        <circle class="st5" cx="66.71" cy="415.39" r="11.8" />
        <circle class="st3" cx="41.31" cy="193.85" r="11.8" />
        <circle class="st3" cx="26.43" cy="535.71" r="11.8" />
        <circle class="st3" cx="51.88" cy="534.94" r="11.8" />
        <circle class="st5" cx="144.16" cy="22.74" r="11.8" />
        <circle class="st5" cx="93.73" cy="56.18" r="11.8" />
        <circle class="st5" cx="66.78" cy="83.58" r="11.8" />
        <circle class="st4" cx="42.58" cy="155.18" r="6.12" />
        <circle class="st4" cx="142.7" cy="76.9" r="6.12" />
        <circle class="st4" cx="142.36" cy="101.59" r="6.12" />
        <circle class="st4" cx="53.27" cy="558.03" r="6.12" />
        <circle class="st4" cx="26.56" cy="557.69" r="6.12" />
        <circle class="st4" cx="93.64" cy="409.8" r="6.12" />
        <circle class="st1" cx="16.61" cy="241.47" r="5.28" />
        <circle class="st1" cx="16.61" cy="217.01" r="5.28" />
        <circle class="st1" cx="16.61" cy="288.44" r="5.28" />
        <circle class="st1" cx="16.61" cy="312.1" r="5.28" />
        <circle class="st1" cx="16.04" cy="337.13" r="5.28" />
        <circle class="st1" cx="16.48" cy="363.3" r="5.28" />
        <circle class="st1" cx="16.7" cy="392.45" r="5.28" />
        <circle class="st1" cx="16.7" cy="417.66" r="5.28" />
        <circle class="st1" cx="16.61" cy="263.43" r="5.28" />
        <circle class="st6" cx="17.03" cy="153.31" r="7.2" />
        <circle class="st1" cx="17.41" cy="114.72" r="5.28" />
        <circle class="st1" cx="17.41" cy="95.19" r="5.28" />
        <circle class="st1" cx="42.64" cy="114.11" r="5.28" />
        <circle class="st1" cx="42.64" cy="94.59" r="5.28" />
        <circle class="st1" cx="42.64" cy="75.16" r="5.28" />
        <circle class="st1" cx="42.64" cy="55.64" r="5.28" />
        <circle class="st1" cx="65.47" cy="61.01" r="5.28" />
        <circle class="st1" cx="65.47" cy="41.58" r="5.28" />
        <circle class="st1" cx="65.47" cy="22.06" r="5.28" />
        <circle class="st1" cx="92.77" cy="32.36" r="5.28" />
        <circle class="st1" cx="92.77" cy="12.84" r="5.28" />
        <circle class="st1" cx="118.96" cy="12.21" r="5.28" />
        <circle class="st6" cx="17.03" cy="133.91" r="7.2" />
        <circle class="st1" cx="28.5" cy="578.27" r="5.28" />
        <circle class="st1" cx="28.5" cy="597.79" r="5.28" />
        <circle class="st1" cx="77.43" cy="577.41" r="5.28" />
        <circle class="st1" cx="52.29" cy="577.59" r="5.28" />
        <circle class="st1" cx="52.29" cy="597.12" r="5.28" />
        <circle class="st1" cx="92.31" cy="506.04" r="5.28" />
        <circle class="st1" cx="116.5" cy="484.68" r="5.28" />
        <circle class="st1" cx="116.36" cy="505.78" r="5.28" />
        <circle class="st1" cx="116.15" cy="531.43" r="5.28" />
        <circle class="st1" cx="116.01" cy="555.27" r="5.28" />
        <circle class="st7" cx="165.9" cy="166.25" r="10.18" />
        <circle class="st7" cx="165.32" cy="189.63" r="10.18" />
        <circle class="st8" cx="189.1" cy="189.97" r="10.18" />
        <circle class="st0" cx="164.79" cy="240.35" r="11.97" />
        <circle class="st0" cx="288.72" cy="242.6" r="11.97" />
        <circle class="st0" cx="312.62" cy="242.69" r="11.97" />
        <circle class="st0" cx="313.68" cy="462.35" r="10.56" />
        <circle class="st0" cx="288.79" cy="535" r="13.31" />
        <circle class="st0" cx="313.11" cy="535.45" r="13.31" />
        <circle class="st0" cx="337.71" cy="534.91" r="13.31" />
        <circle class="st0" cx="338.21" cy="510.14" r="13.31" />
        <circle class="st0" cx="337.51" cy="486.17" r="11.37" />
        <circle class="st0" cx="289.5" cy="267.06" r="12.38" />
        <circle class="st0" cx="313.18" cy="292.35" r="12.38" />
        <circle class="st0" cx="288.99" cy="291.35" r="12.38" />
        <circle class="st0" cx="263.68" cy="364.88" r="12.38" />
        <circle class="st0" cx="214.39" cy="410.95" r="12.93" />
        <circle class="st0" cx="213.86" cy="435.17" r="12.93" />
        <circle class="st0" cx="213.96" cy="460.19" r="12.93" />
        <circle class="st0" cx="165.38" cy="459.63" r="12.93" />
        <circle class="st0" cx="140.26" cy="481.41" r="12.93" />
        <circle class="st0" cx="189.4" cy="240.17" r="10.37" />
        <circle class="st0" cx="164.95" cy="264.25" r="10.37" />
        <circle class="st0" cx="165.11" cy="288.45" r="10.37" />
        <circle class="st0" cx="214.64" cy="361.16" r="10.37" />
        <circle class="st0" cx="237.82" cy="361.61" r="10.37" />
        <circle class="st0" cx="264.97" cy="241.91" r="10.37" />
        <circle class="st0" cx="165.75" cy="312.75" r="10.37" />
        <circle class="st0" cx="165.03" cy="483.3" r="10.37" />
        <circle class="st0" cx="239.14" cy="557.41" r="11.83" />
        <circle class="st0" cx="188.52" cy="557.77" r="11.83" />
        <circle class="st0" cx="189.12" cy="288.49" r="10.37" />
        <circle class="st0" cx="189.13" cy="312.8" r="10.37" />
        <circle class="st8" cx="164.62" cy="214.86" r="7.95" />
        <circle class="st8" cx="264.23" cy="389.13" r="7.95" />
        <circle class="st8" cx="313.36" cy="487.03" r="7.95" />
        <circle class="st8" cx="289.04" cy="511.01" r="10.72" />
        <circle class="st8" cx="140.44" cy="264.76" r="8.84" />
        <circle class="st8" cx="140.29" cy="410.92" r="8.84" />
        <circle class="st8" cx="190.25" cy="435.08" r="9.89" />
        <circle class="st8" cx="139.91" cy="456.01" r="8.84" />
        <circle class="st8" cx="165.45" cy="581.62" r="8.84" />
        <circle class="st8" cx="116.05" cy="581.62" r="8.84" />
        <circle class="st9" cx="140.8" cy="288.25" r="10.47" />
        <circle class="st9" cx="140.81" cy="313.23" r="11.37" />
        <circle class="st9" cx="238.04" cy="337.98" r="11.37" />
        <circle class="st9" cx="140.61" cy="337.98" r="13.15" />
        <circle class="st9" cx="214.92" cy="386.11" r="13.15" />
        <circle class="st9" cx="140.11" cy="386.42" r="13.15" />
        <circle class="st9" cx="165.39" cy="337.49" r="13.15" />
        <circle class="st9" cx="188.64" cy="337.06" r="13.15" />
        <circle class="st9" cx="288.57" cy="316.21" r="13.15" />
        <circle class="st9" cx="311.8" cy="316.54" r="13.15" />
        <circle class="st9" cx="288.4" cy="560.13" r="13.15" />
        <circle class="st9" cx="264.46" cy="535.14" r="10.14" />
        <circle class="st9" cx="337.86" cy="388.87" r="10.14" />
        <circle class="st10" cx="214.21" cy="240.61" r="14.61" />
        <circle class="st10" cx="338.11" cy="242.44" r="13.58" />
        <circle class="st10" cx="338.58" cy="267.31" r="13.58" />
        <circle class="st10" cx="338.81" cy="291.78" r="13.58" />
        <circle class="st10" cx="337.73" cy="316.89" r="13.58" />
        <circle class="st10" cx="337.53" cy="340.69" r="13.58" />
        <circle class="st10" cx="338.17" cy="364.55" r="13.58" />
        <circle class="st10" cx="264.41" cy="267.12" r="13.58" />
        <circle class="st10" cx="263.99" cy="291.89" r="13.58" />
        <circle class="st10" cx="264.62" cy="316.65" r="13.58" />
        <circle class="st10" cx="264.38" cy="340.68" r="13.58" />
        <circle class="st10" cx="288.31" cy="340.68" r="13.58" />
        <circle class="st10" cx="288.31" cy="365.68" r="13.58" />
        <circle class="st10" cx="288.31" cy="389.61" r="13.58" />
        <circle class="st10" cx="288.2" cy="413.54" r="13.58" />
        <circle class="st10" cx="288.35" cy="438.57" r="13.58" />
        <circle class="st10" cx="313.31" cy="340.68" r="13.58" />
        <circle class="st10" cx="313.31" cy="365.68" r="13.58" />
        <circle class="st10" cx="313.31" cy="389.61" r="13.58" />
        <circle class="st10" cx="313.2" cy="413.54" r="13.58" />
        <circle class="st10" cx="313.35" cy="438.57" r="13.58" />
        <circle class="st10" cx="288.77" cy="462.23" r="13.58" />
        <circle class="st10" cx="288.77" cy="487.74" r="13.58" />
        <circle class="st10" cx="214.21" cy="264.88" r="14.61" />
        <circle class="st10" cx="238.93" cy="263.97" r="14.19" />
        <circle class="st10" cx="238.85" cy="291.15" r="14.19" />
        <circle class="st10" cx="238.92" cy="312.86" r="14.19" />
        <circle class="st10" cx="213.63" cy="288.57" r="14.61" />
        <circle class="st10" cx="214.79" cy="314" r="14.61" />
        <circle class="st10" cx="215.95" cy="337.11" r="14.61" />
        <circle class="st10" cx="140.49" cy="362.39" r="14.61" />
        <circle class="st10" cx="165.85" cy="362.59" r="14.61" />
        <circle class="st10" cx="166.1" cy="385.5" r="14.61" />
        <circle class="st10" cx="164.67" cy="412.18" r="14.61" />
        <circle class="st10" cx="189.35" cy="410.82" r="14.61" />
        <circle class="st10" cx="164.88" cy="435.62" r="14.61" />
        <circle class="st10" cx="213.65" cy="483.92" r="14.61" />
        <circle class="st10" cx="214.07" cy="508.36" r="14.61" />
        <circle class="st10" cx="213.64" cy="531.91" r="14.78" />
        <circle class="st10" cx="213.61" cy="556.8" r="14.78" />
        <circle class="st10" cx="141.27" cy="581.76" r="14.78" />
        <circle class="st10" cx="140.51" cy="557.38" r="14.78" />
        <circle class="st10" cx="140.63" cy="532.5" r="14.78" />
        <circle class="st10" cx="141.11" cy="507.77" r="14.78" />
        <circle class="st10" cx="190.46" cy="386.02" r="12.86" />
        <circle class="st10" cx="189.9" cy="362.9" r="14.61" />
        <circle class="st8" cx="189.16" cy="215.4" r="7.95" />
        <circle class="st8" cx="288.61" cy="218.83" r="7.95" />
        <circle class="st8" cx="313.54" cy="218.32" r="7.95" />
        <circle class="st8" cx="362.44" cy="291.34" r="9.79" />
        <circle class="st8" cx="362.44" cy="364.21" r="9.79" />
        <circle class="st11" cx="363" cy="314.71" r="11.8" />
        <circle class="st11" cx="363.5" cy="339.74" r="11.8" />
        <circle class="st8" cx="362.35" cy="266.99" r="7.95" />
        <circle class="st8" cx="338.03" cy="461.81" r="7.95" />
        <circle class="st7" cx="189.68" cy="166.83" r="6.12" />
        <circle class="st7" cx="288.86" cy="193.99" r="6.12" />
        <circle class="st7" cx="312.86" cy="193.78" r="6.12" />
        <circle class="st7" cx="337.44" cy="413.67" r="6.12" />
        <circle class="st7" cx="337.84" cy="438.07" r="6.12" />
        <circle class="st12" cx="386.71" cy="339.75" r="6.12" />
        <circle class="st12" cx="386.59" cy="316.19" r="6.12" />
        <circle class="st7" cx="237.89" cy="409.93" r="4.56" />
        <circle class="st7" cx="237.76" cy="425.62" r="3.5" />
        <circle class="st12" cx="386.51" cy="291.86" r="3.5" />
        <circle class="st12" cx="386.67" cy="364.18" r="3.5" />
        <circle class="st7" cx="238.51" cy="239.36" r="6.12" />
        <circle class="st6" cx="289.04" cy="169.55" r="6.12" />
        <circle class="st6" cx="213.6" cy="215.13" r="7.2" />
        <circle class="st6" cx="142.83" cy="215.76" r="7.2" />
        <circle class="st6" cx="142.74" cy="193.35" r="7.2" />
        <circle class="st6" cx="213.19" cy="193.44" r="7.2" />
        <circle class="st6" cx="212.79" cy="171.14" r="7.2" />
        <circle class="st6" cx="238.23" cy="217.34" r="7.2" />
        <circle class="st6" cx="237.82" cy="195.66" r="7.2" />
        <circle class="st6" cx="237.42" cy="173.36" r="7.2" />
        <circle class="st1" cx="237.95" cy="149.69" r="7.2" />
        <circle class="st6" cx="264.33" cy="216.64" r="7.2" />
        <circle class="st6" cx="263.91" cy="194.96" r="7.2" />
        <circle class="st6" cx="263.51" cy="172.66" r="7.2" />
        <circle class="st1" cx="264.05" cy="149" r="7.2" />
        <circle class="st13" cx="338.12" cy="193.51" r="7.2" />
        <circle class="st13" cx="337.7" cy="171.83" r="7.2" />
        <circle class="st6" cx="337.3" cy="149.53" r="7.2" />
        <circle class="st1" cx="337.84" cy="125.86" r="7.2" />
        <circle class="st6" cx="313.95" cy="146.82" r="7.2" />
        <circle class="st6" cx="313.54" cy="125.14" r="7.2" />
        <circle class="st6" cx="313.14" cy="102.84" r="7.2" />
        <circle class="st1" cx="313.68" cy="79.17" r="7.2" />
        <circle class="st6" cx="288.53" cy="148.27" r="7.2" />
        <circle class="st6" cx="288.12" cy="126.59" r="7.2" />
        <circle class="st6" cx="287.72" cy="104.29" r="7.2" />
        <circle class="st1" cx="288.25" cy="80.63" r="7.2" />
        <circle class="st6" cx="361.07" cy="222.07" r="7.2" />
        <circle class="st6" cx="360.66" cy="200.38" r="7.2" />
        <circle class="st6" cx="360.26" cy="178.08" r="7.2" />
        <circle class="st1" cx="360.79" cy="154.42" r="7.2" />
        <circle class="st6" cx="386.01" cy="531.27" r="7.2" />
        <circle class="st14" cx="363.59" cy="535.11" r="9.11" />
        <circle class="st14" cx="240.41" cy="534.07" r="9.11" />
        <circle class="st6" cx="385.62" cy="508.97" r="7.2" />
        <circle class="st6" cx="363.52" cy="509.47" r="7.2" />
        <circle class="st6" cx="362.76" cy="486.18" r="7.2" />
        <circle class="st6" cx="362.76" cy="462.47" r="7.2" />
        <circle class="st1" cx="386.15" cy="485.31" r="7.2" />
        <circle class="st6" cx="339.12" cy="608.75" r="7.2" />
        <circle class="st6" cx="338.72" cy="586.45" r="7.2" />
        <circle class="st1" cx="339.26" cy="562.79" r="7.2" />
        <circle class="st6" cx="314.65" cy="608.07" r="7.2" />
        <circle class="st6" cx="314.25" cy="585.77" r="7.2" />
        <circle class="st1" cx="314.79" cy="562.11" r="7.2" />
        <circle class="st1" cx="237.54" cy="128.01" r="7.2" />
        <circle class="st1" cx="237.14" cy="105.71" r="7.2" />
        <circle class="st1" cx="119.13" cy="237.95" r="7.2" />
        <circle class="st1" cx="165.39" cy="143.13" r="7.2" />
        <circle class="st1" cx="164.98" cy="121.45" r="7.2" />
        <circle class="st1" cx="164.58" cy="99.15" r="7.2" />
        <circle class="st1" cx="143.26" cy="147.55" r="5.28" />
        <circle class="st1" cx="143.26" cy="128.03" r="5.28" />
        <circle class="st1" cx="237.85" cy="463.07" r="5.28" />
        <circle class="st1" cx="237.85" cy="443.55" r="5.28" />
        <circle class="st1" cx="237.85" cy="503.16" r="5.28" />
        <circle class="st1" cx="237.85" cy="483.64" r="5.28" />
        <circle class="st1" cx="214.15" cy="620.34" r="5.28" />
        <circle class="st1" cx="214.15" cy="600.82" r="5.28" />
        <circle class="st1" cx="190.13" cy="146.56" r="7.2" />
        <circle class="st1" cx="189.72" cy="124.88" r="7.2" />
        <circle class="st1" cx="189.32" cy="102.58" r="7.2" />
        <circle class="st15" cx="119.35" cy="308.04" r="7.2" />
        <circle class="st15" cx="118.94" cy="286.36" r="7.2" />
        <circle class="st1" cx="119.4" cy="423.03" r="7.2" />
        <circle class="st1" cx="118.99" cy="401.35" r="7.2" />
        <circle class="st1" cx="117.76" cy="465.87" r="7.2" />
        <circle class="st1" cx="118.44" cy="444.19" r="7.2" />
        <circle class="st15" cx="118.54" cy="264.06" r="7.2" />
        <circle class="st15" cx="119.81" cy="375.3" r="7.2" />
        <circle class="st15" cx="119.4" cy="353.62" r="7.2" />
        <circle class="st15" cx="119" cy="331.32" r="7.2" />
        <circle class="st6" cx="142.88" cy="169.49" r="7.2" />
        <circle class="st1" cx="361.38" cy="109.94" r="5.28" />
        <circle class="st1" cx="361.38" cy="90.42" r="5.28" />
        <circle class="st6" cx="361" cy="131.88" r="7.2" />
        <circle class="st6" cx="264.49" cy="560.47" r="7.2" />
        <circle class="st6" cx="263.06" cy="517.51" r="7.2" />
        <circle class="st1" cx="263.6" cy="493.84" r="7.2" />
        <circle class="st6" cx="263.81" cy="471.31" r="7.2" />
        <circle class="st1" cx="385.17" cy="205.1" r="5.28" />
        <circle class="st1" cx="385.17" cy="185.57" r="5.28" />
        <circle class="st6" cx="384.79" cy="227.03" r="7.2" />
        <circle class="st6" cx="384.79" cy="248.78" r="7.2" />
        <circle class="st1" cx="385.09" cy="435.08" r="5.28" />
        <circle class="st1" cx="385.09" cy="454.6" r="5.28" />
        <circle class="st1" cx="362.52" cy="411.22" r="5.28" />
        <circle class="st1" cx="362.52" cy="430.74" r="5.28" />
        <circle class="st6" cx="385.47" cy="413.14" r="7.2" />
        <circle class="st6" cx="385.47" cy="391.39" r="7.2" />
        <circle class="st6" cx="384.96" cy="268.62" r="7.2" />
        <circle class="st6" cx="190.13" cy="626.86" r="7.2" />
        <circle class="st6" cx="190.28" cy="603" r="7.2" />
        <circle class="st6" cx="165.13" cy="629.86" r="7.2" />
        <circle class="st6" cx="165.27" cy="606" r="7.2" />
        <circle class="st6" cx="165.42" cy="651.76" r="7.2" />
        <circle class="st6" cx="140.84" cy="633.94" r="7.2" />
        <circle class="st6" cx="140.98" cy="610.08" r="7.2" />
        <circle class="st6" cx="187.49" cy="531.94" r="7.2" />
        <circle class="st6" cx="187.64" cy="508.09" r="7.2" />
        <circle class="st6" cx="314.3" cy="169.48" r="6.12" />
        <circle class="st13" cx="338.34" cy="216.94" r="6.12" />
        <circle class="st6" cx="361.81" cy="242.62" r="6.12" />
        <circle class="st6" cx="363.23" cy="390.27" r="6.12" />
        <circle class="st6" cx="263.94" cy="431.3" r="6.12" />
        <circle class="st6" cx="263.8" cy="449.13" r="6.12" />
        <circle class="st7" cx="238.37" cy="386.02" r="6.12" />
        <circle class="st7" cx="264.04" cy="410.48" r="6.12" />
        <circle class="st7" cx="312.97" cy="509.94" r="6.12" />
        <circle class="st7" cx="164.7" cy="531.81" r="6.12" />
        <circle class="st6" cx="188.62" cy="483" r="5.19" />
        <circle class="st7" cx="189.48" cy="459.47" r="6.12" />
        <circle class="st7" cx="189.83" cy="580.99" r="7.04" />
        <circle class="st7" cx="213.96" cy="581.63" r="7.04" />
        <circle class="st7" cx="141.33" cy="435.19" r="6.12" />
        <circle class="st7" cx="165.05" cy="550.48" r="6.12" />
        <circle class="st7" cx="140.66" cy="239.93" r="6.12" />
        <circle class="st7" cx="165.41" cy="508.68" r="8.86" />
        <path
          class="st16"
          d="M234.87,65.55c-22.75,0-41.19,18.44-41.19,41.19c0,22.75,18.44,41.19,41.19,41.19s41.19-18.44,41.19-41.19
		C276.06,83.99,257.62,65.55,234.87,65.55z M234.87,135.79c-16.05,0-29.05-13.01-29.05-29.05s13.01-29.05,29.05-29.05
		s29.05,13.01,29.05,29.05S250.92,135.79,234.87,135.79z"
        />
        <circle class="st17" cx="190.33" cy="86.52" r="37.01" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.st0 {
  fill: #ff5b85;
}
.st1 {
  fill: #00b649;
}
.st2 {
  fill: #fca5b7;
}
.st3 {
  fill: #0084e1;
}
.st4 {
  fill: #fdb667;
}
.st5 {
  fill: #f2e9ed;
}
.st6 {
  fill: #ffa318;
}
.st7 {
  fill: #006aba;
}
.st8 {
  fill: #00eb7d;
}
.st9 {
  fill: #00a9ff;
}
.st10 {
  fill: #95e9ba;
}
.st11 {
  fill: #178659;
}
.st12 {
  fill: #f23100;
}
.st13 {
  fill: #ff3240;
}
.st14 {
  fill: #ff7193;
}
.st15 {
  fill: #ee6c8f;
}
.st16 {
  fill: #f2e2ea;
}
.st17 {
  fill: #e597c0;
}
.st18 {
  fill: #f6cfaa;
}
.st19 {
  fill: #f8dbc4;
}
.st20 {
  fill: #fbb3c6;
}
.st21 {
  fill: #f6adc1;
}
.st22 {
  fill: #fa98b1;
}
.st23 {
  fill: #e42906;
}
.st24 {
  fill: #0770d3;
}

#Heart_left {
  animation: pulse6 1.3s infinite;
  transform-origin: center;
  transform-box: border-box;
}

#Heart_right {
  animation: pulse 1s infinite;
  transform-origin: center;
  transform-box: border-box;
}
@keyframes pulse {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  30% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pulse6 {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  75% {
    /* Example change */
    transform: scale(1);
    opacity: 1;
  }
}

.svg-container {
  width: 80%;

  @media (max-width: 1199px) {
    width: 90%;
  }
}

.st0 {
  fill: #ff5b85;
}
.st1 {
  fill: #f2e9ed;
}
.st2 {
  fill: #178659;
}
.st3 {
  fill: #00b649;
}
.st4 {
  fill: #95e9ba;
}
.st5 {
  fill: #00eb7d;
}
.st6 {
  fill: #f2e2ea;
}
.st7 {
  fill: #fca5b7;
}
.st8 {
  fill: #ff7193;
}
.st9 {
  fill: #ff3240;
}
.st10 {
  fill: #f23100;
}
.st11 {
  fill: #ee6c8f;
}
.st12 {
  fill: #f8dbc4;
}
.st13 {
  fill: #fbb3c6;
}
.st14 {
  fill: #f6adc1;
}
.st15 {
  fill: #fa98b1;
}
.st16 {
  fill: #e42906;
}
.st17 {
  fill: #0770d3;
}
</style>


// WEBPACK FOOTER //
// src/components/Svg/PeopleMobile.vue